import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import Layout from "./components/Layout";
import Dashboard from "./components/Dashboard";
import SummarizePage from "./components/SummarizePage";
import ChannelsPage from "./components/ChannelsPage";
import HistoryPage from "./components/HistoryPage";
import SummaryDetailPage from "./components/SummaryDetailPage";
import GraphPage from "./components/GraphPage";
import AutomationPage from "./components/AutomationPage";
import SettingsPage from "./components/SettingsPage";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="graph" element={<GraphPage />} />
              <Route path="summarize" element={<SummarizePage />} />
              <Route path="channels" element={<ChannelsPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="summary/:id" element={<SummaryDetailPage />} />
              <Route path="automation" element={<AutomationPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
